<template>
    <section class="section">
        <div class="title">资讯收藏夹</div>
        <div class="count">0个资讯</div>
        <div class="empty">
            <i class="icon-empty"></i>
            空间主人暂时还未收藏资讯哦~
        </div>
    </section>
</template>

<script>
    export default {
        name: "Home",
        beforeMount() {

        }
    }
</script>

<style scoped>
    @import "../../../../static/css/views/space/collect/common.css";
    @import "../../../../static/css/views/space/collect/info.css";
</style>


// WEBPACK FOOTER //
// src/views/space/collect/Info.vue